import type { Language } from '@offer-catalog/services/i18n'
import { VpButton, VpIcon, VpLoader } from '@vtmn-play/react/headless'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import { Breadcrumb } from '@/components/Breadcrumb'
import { useDepartmentPic, useSubdepartments } from '@/hooks/catalog'
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from '@/services/analytics'
import { getBreadcrumbForSubdepPage } from '@/utils/breadcrumb'
import { SubdepartmentsContent } from './SubdepartmentsContent'
import './subdepartments.scss'

export function Subdepartments() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language
  const params = useParams()
  const universeId = params.universeId
  const departmentId = params.departmentId
  const season = params.season as string

  const { data: fullDepartment } = useSubdepartments(
    season,
    Number(universeId),
    Number(departmentId),
  )

  const { data: departmentImageUrl } = useDepartmentPic([Number(departmentId)])

  const showAllProducts = async () => {
    trackAnalyticsEvent(ANALYTICS_EVENTS.NAV_ALL_PRODUCTS_CLICKED, {
      season,
      universe_id: Number(universeId),
      department_id: Number(departmentId),
    })

    await navigate(`/${season}/universe/${universeId}/department/${departmentId}/all-families`)
  }

  const imageUrl = departmentImageUrl?.[Number(departmentId)]

  return fullDepartment
    ? (
        <div
          data-testid="subdepartments-container"
          className="subdepartments-container"
        >
          <div
            className="subdepartments-header"
            data-testid="subdepartments-header"
          >
            <Breadcrumb
              levels={getBreadcrumbForSubdepPage(fullDepartment, currentLanguage)}
            />
            <div className="subdepartments-hero">
              {imageUrl
                ? (
                    <img src={`${imageUrl}?format=auto&f=969x0`} alt="" aria-hidden="true" />
                  )
                : <VpIcon name="image" size={48} />}
            </div>
            <div className="subdepartments-title-department">
              <h1>
                {fullDepartment.labels?.[currentLanguage]
                  || fullDepartment.id.toString()}
              </h1>
              <VpButton
                size="small"
                variant="secondary"
                data-testid="show-all-products_button"
                onClick={() => showAllProducts()}
              >
                {t('select-all-products')}
                <VpIcon name="chevron-forward" />
              </VpButton>
            </div>
          </div>
          <SubdepartmentsContent department={fullDepartment} season={season} />
        </div>
      )
    : (
        <div className="loader-container global">
          <VpLoader />
        </div>
      )
}
